<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Αναφορά Τιμολογίων</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            :sorter-value="sorterValue"
            @row-clicked="(item) => showInvoice(item.id)"
            clickable-rows
          >
          <template #payment_status-filter>
            <div class="selectFilter">
              <CSelect
                :options="payment_options"
                :value.sync="payment_options_selected"
              />
            </div>
          </template>
          <template #document_series_name-filter>
            <div class="selectFilter">
              <CSelect
                :options="document_series_options"
                :value.sync="document_series_options_selected"
              />
            </div>
          </template>
          <template #invoice_date-filter="">
            <span>Από:</span>
            <input
              type="date"
              :value="new Date(startDate).toISOString().substr(0, 10)"
              @change="setDateFilter"
              class="paddingBottomFormControl"
            /><br>
            <span>Έως:</span>
            <input
              type="date"
              :value="new Date(endDate).toISOString().substr(0, 10)"
              @change="e => setDateFilter(e, 'end')"
            />        
          </template>
          <template #payment_status="{item}">
            <td>
              {{ payment_options[item.payment_status + 1] }}
            </td>
          </template>
           <template #total_price="{item}">
            <td>
              {{ item.total_price }}€
            </td>
          </template>
          <template #remaining_price="{item}">
            <td>
              {{ item.remaining_price }}€
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editInvoice( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import js2excel from 'js2excel';
import moment from 'moment'

const fields = [
  {
    key: 'document_number',
    label: 'Α/Α'
  },
  {
    key: 'document_series_name',
    label: 'Τύπος Τιμολογίου'
  },
  {
    key: 'invoice_date',
    label: 'Ημερ. Τιμολόγησης'
  },
  {
    key: 'total_price',
    label: 'Αρχικό Ποσό'
  },
  { 
    key: 'payment_status', 
    label: 'Κατάσταση πληρωμής'
  },
  { 
    key: 'remaining_price', 
    label: 'Υπολειπόμενο ποσό'
  },
  {
    key: 'client_company',
    label: 'Πελάτης'
  },
  {
    key: 'consultant_name',
    label: 'Σύμβουλος'
  },
  {
    key: 'comment',
    label: 'Σχόλιο'
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'InvoiceReports',
  data: () => {
    return {
      tempArr: [],
      sorterValue: { column: 'status', asc: false },
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      payment_options_selected: 'Καμία επιλογή',
      startDate: moment(new Date()).subtract(12, 'M').format('YYYY-MM-DD'),
      endDate: moment(new Date()).add(12, 'M').format('YYYY-MM-DD'),
      disabledFilter: true,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      loading: true,
      showDismissibleAlert: false,
      payment_options: [],
      document_series_options: [],
      document_series_options_selected: 'Καμία επιλογή',
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {

      let temp = this.items.filter((item) => {
        let date = moment(item.invoice_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

        if (this.startDate && this.endDate) return date >= this.startDate && date <= this.endDate
        if (this.startDate) return date >= this.startDate
        if (this.endDate) return date <= this.endDate

        return true
      });

      if (this.document_series_options_selected != "Καμία επιλογή") {
        temp = temp.filter(item => {
          return item.document_series_name == this.document_series_options_selected;
      });
  }

      if (this.payment_options_selected == "Καμία επιλογή") {
        return temp;
      }
      return temp.filter(item => {
        let status = this.payment_options[item.payment_status + 1];
        return status == this.payment_options_selected;
      })
    },
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.filteredItems.map((item) => {
        return {
          Αριθμός: item.document_number,
          Τύπος: item.document_series_name,
          Ημερομηνία : item.invoice_date,
          Αρχικό_Ποσό: item.total_price+'€',
          Κατάσταση: this.payment_options[item.payment_status + 1],
          Υπολειπόμενο_Ποσό: item.remaining_price+'€',
          Πελάτης: item.client_company,
          Σύμβουλος: item.consultant_name,
          Σχόλιο: item.comment
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'invoices-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    setDateFilter (e, end) {
      if (end) {
        if (e.target.value) {
          this.endDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
        } else {
          this.endDate = null
        }
      } else {
        if (e.target.value) {
          this.startDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
        } else {
          this.startDate = null
        }
      }
    },
    getTotalPrice(services) {
      let sum = services.reduce(function (accumulator, item) {
        return accumulator + parseFloat(item.total_price)
      }, 0);
      return sum.toFixed(2);
    },
    invoiceLink (id) {
      return `invoices/${id.toString()}`
    },
    editLink (id) {
      return `invoices/${id.toString()}/edit`
    },
    showInvoice ( id ) {
      const invoiceLink = this.invoiceLink( id );
      this.$router.push({path: invoiceLink});
    },
    editInvoice ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInvoiceReports (){
      let self = this;

      axios.get('/api/invoices/reports?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.invoices.map((item) => {
          return {
            id: item.id,
            client_company: item.client_company,
            consultant_name: item.consultant_name || '-',
            document_number: item.document_number,
            total_price: self.getTotalPrice(item.invoices_cases),
            remaining_price: (self.getTotalPrice(item.invoices_cases) - parseFloat(item.paid_amount)).toFixed(2),
            payment_status: item.payment_status,
            invoice_date: item.invoice_date,
            document_series_name: item.document_series.greek_name,
            comment: item.payment_comment !== null ? item.payment_comment : ''
          }
        });

        self.payment_options =  ['Καμία επιλογή', ...response.data.payment_options];
        self.document_series_options = ['Καμία επιλογή', ...response.data.document_options]
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
  },
  mounted: function(){
    this.getInvoiceReports();
  }
}
</script>